import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TPostSendPushNotificationsRequest } from "./postSendPushNotificationsRequestSchema";

export type TPostSendPushNotificationsResponse = {
  jobId: string;
  status: "queued";
};

export const postSendPushNotifications = (axios: IAxiosInstance) => {
  return async (data: TPostSendPushNotificationsRequest) => {
    const response = await axios.noRetry.post<
      ZealApiResponse<TPostSendPushNotificationsResponse>
    >("/api/internal-tools/send-push-notifications", { ...data });
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
